/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { globalBreak } from '@/styles/break';
import { SxProps, Theme } from '@mui/material';

export const layoutItemWrapSX: SxProps<Theme> = {
	'&:empty': {
		display: 'none',
	},
	'& >:not(.MuiGrid-item):not(:empty):not(:has(br:only-child)):not(:has(hr:only-child))':{
		pb:globalBreak({mobile:1.5, desktop:2.5})
	},
	'& >.MuiGrid-container:not(:empty):not(:has(br:only-child)):not(:has(hr:only-child))':{
		pb:0
	},
	'& >.MuiPaper-root:not(:empty):not(:has(br:only-child)):not(:has(hr:only-child))':{
		pb:0
	}
	
};
